import UiReducer from './UiReducer';

const rootReducer = {
	ui: UiReducer.reducer,
};

export default rootReducer;
